import { put, call, takeEvery, takeLatest } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';

import { store } from '~redux/store';
import combinedActions from '~redux/combinedActions';
import { ErrorMessages } from '~utils/constants';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { PayloadAction } from '@reduxjs/toolkit';
import { TGetExportDailyBalancingReportAPIParams } from '~types/feat/dashboard';

export default function* watchExportDailyBalancingReport(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardExportDailyBalancingReportAttempt', handleExportDailyBalancingReport, api);
}

function* handleExportDailyBalancingReport(api: DashboardGateway, action: PayloadAction<TGetExportDailyBalancingReportAPIParams>) {
    const reduxState = store.getState();

    const authToken = reduxState.auth.userDetails.authToken;

    const { date, productId } = action.payload;

    const response = yield* call([api, api.exportDailyBalancingReport], {
        authToken,
        date: date,
        productId: productId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardExportDailyBalancingReportFailure(response.message || ErrorMessages.GenericError));

        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardExportDailyBalancingReportSuccess(response.data));
    }
}
